<template>
  <router-view />
</template>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Encode+Sans+Condensed:wght@400;500;600;700&family=Encode+Sans+Semi+Condensed:wght@400;500;600;700&display=swap");
@import "assets/css/normalize.scss";
@import "assets/css/style.scss";
</style>
